import { render } from "./TopProductsComponent.vue?vue&type=template&id=64d225ea"
import script from "./TopProductsComponent.vue?vue&type=script&lang=js"
export * from "./TopProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/dashboard/TopProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64d225ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64d225ea', __exports__)) {
    api.reload('64d225ea', __exports__)
  }
  
  module.hot.accept("./TopProductsComponent.vue?vue&type=template&id=64d225ea", () => {
    api.rerender('64d225ea', render)
  })

}


export default __exports__